import styled from "@emotion/styled";
import {mq} from "@styles/helpers";
import {Devices} from "@styles/tokens";

export const Content = styled.div`
    
`;

export const AchievementContainer = styled.div`
    display:grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap:20px;
    margin-top: 30px;
    position: relative;
    min-height: 200px;

    ${mq(Devices.laptop)}{
        margin-top: 10px;
        grid-template-columns: 1fr 1fr 1fr;
    }

    ${mq(Devices.mobile)}{
        margin-top: 20px;
        grid-template-columns: 1fr 1fr;
    }
`;

export const Achievement = styled.div<{locked?:boolean}>`
    display:grid;
    grid-template-rows: 20% 51% 7% 22%;
    opacity: ${props => props.locked?"0.4":"1"};
    border-radius: 10px;
    overflow: hidden;
    cursor:pointer;
    aspect-ratio: 1 / 1.3;
    height:100%;
`;

export const AchievementBadge = styled.div<{colors?:any}>`
    width:100%;
    background: ${props => props.colors?.background + "40"};
    grid-row: 1 / span 3;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease-in-out;
    position: relative;
    :hover{
        background: ${props => props.colors?.background + "80"};
    }
`;

export const AchevementProgress = styled.div<{colors?:any, progress?:number}>`
    height:7px;
    width: 100%;
    position: absolute;
    bottom:0;
    left:0;
    background: ${props => props.colors?.background + "20"};
    border-radius: 5px 5px 0 0 ;
    overflow: hidden;

    div{
        background: ${props => props.colors?.background + "80"};
        width:${props => props.progress + "%"};
        height:100%;
    }
`;

export const AchievementText = styled.div`
    display:flex;
    justify-content: center;
    align-items: center;
    background: ${props => props.theme.colors.offWhite};
    text-align: center;
    padding:10px 0;
    font-size: 0.9vw;
    line-height: 0.9vw;
    font-weight: 400;

  ${mq(Devices.tablet)} {
    
      font-size: 2.2vw;
      line-height: 2vw;
    
  }

  ${mq(Devices.mobile)} {
    
      font-size: 3.5vw;
      line-height: 3.2vw;
    
  }
`;